import { type RelayRefetchProp } from 'react-relay';

type VariablesType = { [key: string]: boolean | string };
type CallbackFnType = () => void;

export const handleUserRefetch = (
    relay: RelayRefetchProp,
    setIsClient: (isClient: boolean) => void
): ((
    variables: VariablesType,
    renderVariables: VariablesType,
    callback: CallbackFnType
) => void) => {
    return (variables: VariablesType, renderVariables: VariablesType, callback: CallbackFnType) => {
        const isClient: boolean = variables?.isClient === true;
        setIsClient(isClient);
        /**
         * Only set variables that are directly used by the `SbRespCreatorsLayoutRefetchQuery` and `
         * SbMobileCreatorsLayoutRefetchQuery`queries.
         */
        const { userId, fetchUser, followSearchTypes, rerankUserId, rerankGuestId } = variables;
        relay.refetch(
            {
                userId,
                fetchUser,
                followSearchTypes,
                isClient,
                rerankUserId,
                rerankGuestId,
            },
            null,
            callback
        );
    };
};
